module.exports = __webpack_public_path__ + "assets/img/block-hover-9332af6e.png";